import { useNotify, useRecordContext } from 'react-admin';

import { AdminNotification } from 'api/generated';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { api } from 'api';

const SendNotificationButton = () => {
  const notify = useNotify();

  const record = useRecordContext<AdminNotification>();
  const sendNotification = async () => {
    try {
      await api.V1AdminsPromotionNotificationsApi.adminNotificationsControllerSendNotification(record.id);
      notify('Уведомление отправлено');
    } catch (error: any) {
      notify('Ошибка:', error.message);
    }
  };
  return (
    <Button onClick={() => sendNotification()} style={{ maxWidth: '250px' }} startIcon={<SendIcon />}>
      РАЗОСЛАТЬ УВЕДОМЛЕНИЕ
    </Button>
  );
};

export default SendNotificationButton;
